/**
 * Add Custom Javascript here
 */
window.addEventListener('load', () => {
  const $ = window.jQuery;
  //endorsements carousel
  $('#endorsement-items').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 980,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      }
    ]
  });
  //testimonials carousel
  $('#testimonial-items').slick({
    slidesToShow: 1,
    slidesToScroll: 1
  });

  //toggle mega menu
  $('.site-nav__item--has-dropdown').on(
    'hover',
    function () {
      $(this).find('.mega-menu').slideToggle();
    },
    function () {
      $(this).find('.mega-menu').slideToggle();
    }
  );

  //endorsements carousel
  $('.product-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 980,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      }
    ]
  });

  //press section slider

  $('.press-text-holder').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.press-image-holder'
  });

  $('.press-image-holder').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.press-text-holder',
    dots: false,
    centerMode: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 980,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  //toggle mobile navigation

  $('.toggle-mobile-nav').on('click', function () {
    $('.mobile-nav').toggleClass('mobile-nav-opened');
  });

  $('.toggle-form').on('click', function () {
    $('.popup-title').hide();
    $('.popup-actions').hide();
    $('.exit-popup .newsletter__inline-submit').text('SEND ME MY DISCOUNT');
    $('.popup-text').show();
    $('.exit-popup .newsletter__fields-wrapper').show();
  });
  $('.toggle-exit-popup').on('click', function () {
    $('.exit-popup').hide();
  });
  $('.newsletter .newsletter__inline-submit').text('SIGN UP');
  $('.toggle-klaviyo-form').on('click', function () {
    $('.modal-form').slideToggle();
  });
  
  console.log('mobile-nav', $('#mobile-nav-toggler'));
  setTimeout(() => console.log('mobile-nav', $('#mobile-nav-toggler')), 1000);
  
  $('#mobile-nav-toggler').on('click', function () {
    if ($(this).hasClass('mobile-menu-opened')) {
      $(this).find('img').show();
      $(this).find('span').hide();
      $(this).removeClass('mobile-menu-opened');
      $(`navigation-drawer`).removeClass('open');
      document.querySelector(`body`).style.overflow = '';
      document.querySelectorAll(`sub-menu-container.open`).forEach(subMenu => {
        subMenu.classList.remove('open');
      });
    } else {
      document.querySelector(`body`).style.overflow = 'hidden';
      $(`navigation-drawer`).addClass('open');
      $(this).addClass('mobile-menu-opened');
      $(this).find('img').hide();
      $(this).find('span').show();
    }
  });

  $('.cart-toggle').on('click', function () {
    setTimeout(function () {
      // Make an AJAX request to the products.json endpoint
      var url = 'https://www.artoftea.com/products.json?limit=50';

      $.ajax({
        url: url,
        method: 'GET',
        dataType: 'json',
        success: function (response) {
          // Handle the response data
          var products = response.products;
          var randomProducts = getRandomSubset(products, 4); // Get 4 random products

          // Create the grid layout
          var gridContainer = document.createElement('div');
          gridContainer.className = 'product-grid';

          for (var i = 0; i < randomProducts.length; i++) {
            var product = randomProducts[i];

            // Create a grid item for each product
            var gridItem = document.createElement('div');
            gridItem.className = 'grid-item';

            // Create the product image
            var productImage = document.createElement('img');
            productImage.src = product.images[0].src;
            productImage.alt = product.title;
            productImage.className = 'product-image';

            // Create the product title
            var productTitle = document.createElement('h3');
            productTitle.textContent = product.title;

            // Create the product price
            var productPrice = document.createElement('p');
            productPrice.textContent = '$' + product.variants[0].price;

            // Create the product link
            var productLink = document.createElement('a');
            productLink.href = '/products/' + product.handle;
            productLink.appendChild(productImage);
            productLink.appendChild(productTitle);
            // productLink.appendChild(productPrice);

            // Add the product link to the grid item
            gridItem.appendChild(productLink);

            // Add the grid item to the grid container
            gridContainer.appendChild(gridItem);
          }

          // Add the grid container to the page

          $('#emptyCart-recproducts').html(gridContainer);
        },
        error: function (xhr, status, error) {
          // Handle the error
          console.error(error);
        }
      });

      // Function to get a random subset of products
      function getRandomSubset(arr, size) {
        var shuffled = arr.slice(0);
        var i = arr.length;
        var temp;
        var index;

        while (i--) {
          index = Math.floor((i + 1) * Math.random());
          temp = shuffled[index];
          shuffled[index] = shuffled[i];
          shuffled[i] = temp;
        }

        return shuffled.slice(0, size);
      }
    }, 250);
  });

  setTimeout(function () {
    // Make an AJAX request to the products.json endpoint
    var url = 'https://www.artoftea.com/products.json?limit=50';

    $.ajax({
      url: url,
      method: 'GET',
      dataType: 'json',
      success: function (response) {
        // Handle the response data
        var products = response.products;
        var randomProducts = getRandomSubset(products, 4); // Get 4 random products

        // Create the grid layout
        var gridContainer = document.createElement('div');
        gridContainer.className = 'product-grid';

        for (var i = 0; i < randomProducts.length; i++) {
          var product = randomProducts[i];

          // Create a grid item for each product
          var gridItem = document.createElement('div');
          gridItem.className = 'grid-item';

          // Create the product image
          var productImage = document.createElement('img');
          productImage.src = product.images[0].src;
          productImage.alt = product.title;
          productImage.className = 'product-image';

          // Create the product title
          var productTitle = document.createElement('h3');
          productTitle.textContent = product.title;

          // Create the product price
          var productPrice = document.createElement('p');
          productPrice.textContent = '$' + product.variants[0].price;

          // Create the product link
          var productLink = document.createElement('a');
          productLink.href = '/products/' + product.handle;
          productLink.appendChild(productImage);
          productLink.appendChild(productTitle);
          // productLink.appendChild(productPrice);

          // Add the product link to the grid item
          gridItem.appendChild(productLink);

          // Add the grid item to the grid container
          gridContainer.appendChild(gridItem);
        }

        // Add the grid container to the page

        $('#emptyCartPage-recproducts').html(gridContainer);
      },
      error: function (xhr, status, error) {
        // Handle the error
        console.error(error);
      }
    });

    // Function to get a random subset of products
    function getRandomSubset(arr, size) {
      var shuffled = arr.slice(0);
      var i = arr.length;
      var temp;
      var index;

      while (i--) {
        index = Math.floor((i + 1) * Math.random());
        temp = shuffled[index];
        shuffled[index] = shuffled[i];
        shuffled[i] = temp;
      }

      return shuffled.slice(0, size);
    }
  }, 250);

  $('html body').on('click', '.cart-item__inc-remove', function () {
    console.log('cart removed');
    setTimeout(function () {
      if ($('.empty-cart')[0]) {
        // Make an AJAX request to the products.json endpoint
        var url = 'https://www.artoftea.com/products.json?limit=50';

        $.ajax({
          url: url,
          method: 'GET',
          dataType: 'json',
          success: function (response) {
            // Handle the response data
            var products = response.products;
            var randomProducts = getRandomSubset(products, 4); // Get 4 random products

            // Create the grid layout
            var gridContainer = document.createElement('div');
            gridContainer.className = 'product-grid';

            for (var i = 0; i < randomProducts.length; i++) {
              var product = randomProducts[i];

              // Create a grid item for each product
              var gridItem = document.createElement('div');
              gridItem.className = 'grid-item';

              // Create the product image
              var productImage = document.createElement('img');
              productImage.src = product.images[0].src;
              productImage.alt = product.title;
              productImage.className = 'product-image';

              // Create the product title
              var productTitle = document.createElement('h3');
              productTitle.textContent = product.title;

              // Create the product price
              var productPrice = document.createElement('p');
              productPrice.textContent = '$' + product.variants[0].price;

              // Create the product link
              var productLink = document.createElement('a');
              productLink.href = '/products/' + product.handle;
              productLink.appendChild(productImage);
              productLink.appendChild(productTitle);
              // productLink.appendChild(productPrice);

              // Add the product link to the grid item
              gridItem.appendChild(productLink);

              // Add the grid item to the grid container
              gridContainer.appendChild(gridItem);
            }

            // Add the grid container to the page

            $('#emptyCart-recproducts').html(gridContainer);
          },
          error: function (xhr, status, error) {
            // Handle the error
            console.error(error);
          }
        });

        // Function to get a random subset of products
        function getRandomSubset(arr, size) {
          var shuffled = arr.slice(0);
          var i = arr.length;
          var temp;
          var index;

          while (i--) {
            index = Math.floor((i + 1) * Math.random());
            temp = shuffled[index];
            shuffled[index] = shuffled[i];
            shuffled[i] = temp;
          }

          return shuffled.slice(0, size);
        }
      }
    }, 2000);
  });

  $('html body').on('click', '.btn-bundle-save', function () {
    // Define the discount code
    var discountCode = 'BUNDLENSAVE'; // Replace 'YOUR_DISCOUNT_CODE' with the actual discount code you created in Shopify

    data = {
      id: 39492198498349,
      quantity: 1
    };

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function () {
        // Apply the discount code after adding the product to the cart
        applyDiscountCode(discountCode);
      }
    });
  });

  // Function to apply the discount code to the cart
  function applyDiscountCode(discountCode) {
    Shopify.DiscountApplier.applyDiscount(discountCode, function (cart) {
      // Redirect to the cart page after applying the discount code
      window.location.href = '/cart';
    });
  }

  // $('html body').on('click', '.btn-bundle-save', function () {
  //     // Calculate the discounted price

  //   var discount_code = 'BUNDLENSAVE';

  //  data = {
  //     "id": 39492198498349,
  //     "quantity": 1,
  //     "discount_code": discount_code // discount_code

  //   };

  //   $.ajax({
  //       type: 'POST',
  //       url: '/cart/add.js',
  //       data: data,
  //       dataType: 'json',
  //       success: function() {
  //         // window.location.href = '/cart';
  //       }
  //     });
  // });

  $('html body').on('click', '.cart-checkout-button', function () {
    window.location.href = '/checkout/';
  });
  $('.video_poster').on('click', function () {
    $('.video_poster').hide();
    $('.video_popup').fadeToggle();
  });
  $('.video_popup .close-btn').on('click', function () {
    $('.video_popup').fadeToggle();
    $('.video_poster').show();
  });

  // Global variable to hold the YouTube player instance
  let player;

  // Function to create the YouTube player
  function onYouTubeIframeAPIReady() {
    player = new YT.Player('player', {
      height: '460', // Set the desired height of the player
      width: '640', // Set the desired width of the player
      videoId: 'Dk8I_bWU7YY', // Replace 'VIDEO_ID' with the YouTube video ID you want to play
      playerVars: {
        autoplay: 0, // Set to 1 for autoplay
        controls: 1, // Show video controls
        rel: 0, // Disable related videos at the end
        showinfo: 0 // Hide video title and uploader information
      },
      events: {
        onReady: onPlayerReady // Call onPlayerReady function when the player is ready
      }
    });
  }

  // Function to handle player ready event
  function onPlayerReady(event) {
    // Add a click event listener to the video container
    document.getElementById('close-btn').addEventListener('click', function () {
      // Check if the video is currently playing
      if (player.getPlayerState() === YT.PlayerState.PLAYING) {
        // Pause the video if it's playing
        player.pauseVideo();
      }
    });
  }
  onYouTubeIframeAPIReady();

  // Function to get URL parameters by name
  function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  // Check for the 'variant' parameter in the URL
  var variantId = getParameterByName('variant');

  if (variantId) {
    // Toggle the button with the same ID as the variant
    var button = document.getElementById(variantId);
    if (button) {
      button.trigger('click');
    }
  }
});
